import React, { memo, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Outlet, Route, Routes } from 'react-router-dom';
import { nofollow } from '@treeum/nofollow';
import PropTypes from 'prop-types';

import AppHelmet from '@/components/App/AppHelmet';
import buildRoutes from '@/routes';

function App({ routerContext = null }) {
  const organizationsSlugs = useSelector((state) => state.organizationsSlugs);
  const routes = useMemo(
    () => buildRoutes({ organizationsSlugs }),
    [organizationsSlugs]
  );

  const renderRoute = useCallback(
    ({ component: RouteComponent, id, props, ...routeProps }) => (
      <Route key={id} {...routeProps} element={<RouteComponent {...props} />} />
    ),
    []
  );

  if (typeof document !== 'undefined') {
    const target = document.querySelector('body');

    nofollow({ type: 'client', target });
  }

  return (
    <>
      <AppHelmet />

      <Routes>
        <Route element={<Outlet context={routerContext} />}>
          {routes.map(renderRoute)}
        </Route>
      </Routes>
    </>
  );
}

App.propTypes = {
  routerContext: PropTypes.oneOfType([PropTypes.object]),
};

export default memo(App);
